import Vue from "vue";
import VueCompositionApi from "@vue/composition-api";

Vue.use(VueCompositionApi);

// Trick to avoid: [vue-composition-api] must call Vue.use(VueCompositionAPI) before using any function.
// Since services are created before Plugin is instantiated, we get this error.
// In order to avoid it, we can temporary import vue-composition-api stuff from here...
export * from "@vue/composition-api";
